var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSearchScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M61.5097,59.8786l-1.34167.43494-1.66174-1.66174c1.40662-1.85919,2.17828-4.10773,2.17828-6.47992,0-2.87891-1.12109-5.58594-3.15723-7.62158-2.03516-2.03564-4.74219-3.15723-7.62207-3.15723-2.87891,0-5.58594,1.12109-7.62109,3.15723-2.03613,2.03564-3.15723,4.74268-3.15723,7.62158,0,2.87939,1.12109,5.58643,3.15723,7.62207,2.03516,2.03613,4.74219,3.15723,7.62109,3.15723,2.3725,0,4.62109-.77161,6.48004-2.17816l1.66168,1.66168-.43481,1.34143c-.22595.69696-.04205,1.46173.47601,1.9798l6.32294,6.323c.76141.76135,1.99585.76135,2.75726,0l2.6441-2.6441c.76135-.76141.76135-1.99585,0-2.75726l-6.323-6.32294c-.51807-.51807-1.28284-.70197-1.9798-.47601ZM44.40527,57.67285c-1.46973-1.46924-2.27832-3.42285-2.27832-5.50098,0-2.07764.80859-4.03125,2.27832-5.50049,1.46875-1.46924,3.42285-2.27832,5.5-2.27832,2.07812,0,4.03223.80908,5.50098,2.27832,1.46973,1.46924,2.27832,3.42285,2.27832,5.50049,0,2.07812-.80859,4.03174-2.27832,5.50098-1.46875,1.46924-3.42285,2.27832-5.50098,2.27832-2.07715,0-4.03125-.80908-5.5-2.27832Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M33.9248,64.60107h5.70898v-3h-5.70898c-1.54883,0-2.80859-1.25977-2.80859-2.80859v-21.1864h33.96289v19.21765h3v-23.5415c0-1.49316-.57104-2.85205-1.5-3.8822v-.4267h-.42664c-1.03003-.92908-2.38879-1.50018-3.88196-1.50018h-28.3457c-1.49316,0-2.85193.57111-3.88196,1.50018h-.42639v.42639c-.92908,1.03015-1.50024,2.38922-1.50024,3.88251v25.51025c0,3.20264,2.60547,5.80859,5.80859,5.80859Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSearchScraper);
export default __webpack_public_path__ + "static/media/google-search-scraper.6cf4372ca2a83c70f44780920efd0922.svg";
export { ForwardRef as ReactComponent };